import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Register() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [nomeEmpresa, setNomeEmpresa] = useState("");
  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(false);

  async function handleRegister(e) {
    e.preventDefault();

    const emailFinal = email.trim();
    const senhaFinal = password.trim();

    if (!emailFinal || !senhaFinal) {
      alert("Email e senha são obrigatórios");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("email", emailFinal);
    formData.append("password", senhaFinal);
    formData.append("nomeEmpresa", nomeEmpresa.trim() || "Minha Empresa");

    if (logo) {
      formData.append("logo", logo);
    }

    try {
      const res = await fetch("https://app.nvplaydigital.com/register", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (res.ok) {
        alert("Conta criada com sucesso 🚀");
        navigate("/login");
      } else {
        alert(data.error || "Erro ao criar conta");
      }
    } catch {
      alert("Erro ao conectar com servidor");
    }

    setLoading(false);
  }

  return (
    <div style={container}>
      <div style={card}>
        <h1 style={titulo}>Criar conta</h1>
        <p style={subtitulo}>Cadastre sua empresa no Gestor One</p>

        <form onSubmit={handleRegister}>
          <input
            style={input}
            type="text"
            placeholder="Nome da empresa"
            value={nomeEmpresa}
            onChange={(e) => setNomeEmpresa(e.target.value)}
          />

          <input
            style={input}
            type="email"
            placeholder="E-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            style={input}
            type="password"
            placeholder="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <label style={uploadBox}>
            {logo ? logo.name : "Selecionar logo PNG/JPEG"}
            <input
              type="file"
              accept="image/png, image/jpeg"
              onChange={(e) => setLogo(e.target.files[0])}
              style={{ display: "none" }}
            />
          </label>

          {logo && (
            <img
              src={URL.createObjectURL(logo)}
              alt="preview"
              style={preview}
            />
          )}

          <button style={button} type="submit" disabled={loading}>
            {loading ? "Criando..." : "Criar conta"}
          </button>
        </form>

        <button onClick={() => navigate("/login")} style={link}>
          Já tenho conta
        </button>
      </div>
    </div>
  );
}

const container = {
  minHeight: "100vh",
  background: "linear-gradient(135deg, #020617, #0f172a)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 20,
};

const card = {
  background: "white",
  width: "100%",
  maxWidth: 430,
  padding: 34,
  borderRadius: 20,
  boxShadow: "0 24px 70px rgba(0,0,0,0.4)",
};

const titulo = {
  textAlign: "center",
  margin: 0,
  fontSize: 34,
};

const subtitulo = {
  textAlign: "center",
  color: "#64748b",
  marginBottom: 24,
};

const input = {
  width: "100%",
  padding: 14,
  marginBottom: 14,
  borderRadius: 12,
  border: "1px solid #cbd5e1",
  boxSizing: "border-box",
  fontSize: 15,
};

const uploadBox = {
  display: "block",
  width: "100%",
  padding: 14,
  marginBottom: 14,
  borderRadius: 12,
  border: "1px dashed #94a3b8",
  boxSizing: "border-box",
  color: "#475569",
  cursor: "pointer",
  textAlign: "center",
};

const preview = {
  width: 86,
  height: 86,
  borderRadius: "50%",
  objectFit: "cover",
  display: "block",
  margin: "0 auto 14px",
  border: "3px solid #e5e7eb",
};

const button = {
  width: "100%",
  padding: 14,
  borderRadius: 12,
  border: "none",
  background: "#020617",
  color: "white",
  fontWeight: "bold",
  cursor: "pointer",
  fontSize: 15,
};

const link = {
  display: "block",
  margin: "18px auto 0",
  background: "none",
  border: "none",
  color: "#2563eb",
  cursor: "pointer",
  fontWeight: "bold",
};
